import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';
import { PATTERNS, getYears } from '../../../../globals';

@Component({
    selector: 'bills-search',
    templateUrl: '../../templates/partials/search-bills.html'
})

export class SearchBillsComponent implements OnInit {

    public bills = {
        cif: null,
        legalName: null,
        trademark: null,
        cleaner: null,
        reference: null,
        year: null,
        month: null
    };
    public years = [];
    public paid;
    public type = "cleaner";
    @Output() searchBillsEmitter = new EventEmitter();
    @Output() filterByPaidEmitter = new EventEmitter();

    constructor() { 
        getYears(this.years);
    }

    public searchBills() {
        let period = this.bills["year"] + "-" + this.bills["month"];
        //console.log(period); 
        var object = {
            paid: (this.bills["paid"]) ? this.bills["paid"] : '',
            legal_name: (this.bills["legalName"]) ? this.bills["legalName"].trim() : '',
            trademark: (this.bills["trademark"]) ? this.bills["trademark"].trim() : '',
            cleanerName: (this.bills["cleaner"]) ? this.bills["cleaner"].trim() : '',
            cif: (this.bills["cif"]) ? this.bills["cif"].trim() : '',
            period: (period) ? period : '',
        }

        this.searchBillsEmitter.emit({type: this.type, data: object});
    }

    public filterByPaidBills(event){
        this.filterByPaidEmitter.emit(this.paid);
    }

    ngOnInit() {
        var month = moment().subtract(1, 'months').format("MM");
        //console.log(month);
        this.bills.year = this.years[0];
        this.bills.month = month;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/search-bills.component.ts